import { Link } from "react-router-dom";
import LogoutModal from "../../components/LogoutModal/LogoutModal";
import { useState } from "react";

const UserDropdownContent = ({ data, role }) => {
  const [isLogoutModelOpen, setIsLogOutModelOpen] = useState(false);

  const handleLogoutClick = () => {
    setIsLogOutModelOpen(true);
  };
  return (
    <div className="p-2">
      {/* <div className="text-sm text-gray-900 font-medium">{data.email}</div>
      <div className="text-xs text-gray-500 mb-2">{role}</div> */}
      <hr className="mt-0 mb-3 bg-slate-300 h-0.5" />
      <ul className="text-sm space-y-1">
        {/* <li className="cursor-pointer flex list-none items-center overflow-hidden whitespace-nowrap">
          <Link className="mb-1 p-2 flex gap-2 items-center cursor-pointer overflow-hidden rounded-xl border hover:text-zinc-950 dark:hover:text-zinc-100 grow transition-all duration-300 ease-in-out border-zinc-300 text-zinc-500 dark:border-zinc-800 dark:text-zinc-100 max-md:hidden">
            <div>
              <i class="fa-regular fa-user"></i>
            </div>
            <div>Profile</div>
          </Link>
        </li>
        <li className="cursor-pointer flex list-none items-center overflow-hidden whitespace-nowrap">
          <Link className="mb-1 p-2 flex gap-2 items-center cursor-pointer overflow-hidden rounded-xl hover:text-zinc-950 dark:hover:text-zinc-100 grow transition-all duration-300 ease-in-out text-zinc-500 dark:text-zinc-100 max-md:hidden justify-between">
            <div className="flex items-center gap-2">
              <span>
                <i class="fa-regular fa-envelope"></i>
              </span>
              <div>Inbox</div>
            </div>
            <div className="flex items-center gap-3">
              <span className="bg-blue-700 text-white py-1 px-2 rounded-md leading-none">3</span>
              <Link className="border border-zinc-950 rounded-full w-5 aspect-square flex justify-center items-center leading-none">
                <i class="fa-regular fa-plus"></i>
              </Link>
            </div>
          </Link>
        </li> */}
        <li className="cursor-pointer flex list-none items-center overflow-hidden whitespace-nowrap">
          <button
            onClick={handleLogoutClick}
            className="mb-1 p-2 flex gap-2 items-center overflow-hidden rounded-lg hover:text-red-600 grow transition-all duration-300 ease-in-out text-zinc-600 border border-zinc-300 hover:bg-red-50 group w-full text-left"
          >
            <i className="fa-regular fa-right-from-bracket text-sm" />
            <span>Log Out</span>
          </button>
        </li>
      </ul>
      <LogoutModal
        setIsOpen={setIsLogOutModelOpen}
        isOpen={isLogoutModelOpen}
      />
    </div>
  );
};

export default UserDropdownContent;
